export const SPRITZ_URL = 'https://assets.bwbx.io/s3/spritz/v1/spritz.js';
export const BPLAYER_URLS: Record<string, string> = {
  production:
    'https://assets.bwbx.io/s3/multimedia/projector/latest/bplayer.js',
  staging:
    'https://assets-dev.bwbx.io/s3/multimedia/projector/latest/bplayer.js',
  local: 'http://localhost:7314/bplayer.js',
};
export const DEFAULT_POSTER_SIZE = '400x225';
export const POSTER_EDGE_MAX_LENGTH = 400;
export const DEFAULT_ASPECT_RATIO = '16:9';
